<h3 mat-dialog-title>{{ title }}</h3>

<mat-dialog-content>
    <app-google-auth-setup-step (completed)="onCompleted()"
                                (showingRecoveryCodes)="onShowingRecoveryCodes()"
                                (cancelled)="onCancelled()"></app-google-auth-setup-step>
</mat-dialog-content>
